const formatNumber = number =>
  new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(number);
const getLanguageName = languageCode =>
  new Intl.DisplayNames(['en'], { type: 'language' }).of(languageCode);

export { formatNumber, getLanguageName };
